export default __webpack_public_path__ + "static/payroll-for-teams-generate-report-f587ef2a342538c8c0b0763268fb01c4.png";